<template>
  <div style="z-index:999" :style="divStyle">
    <expandGasAppliances
      :call-back="getGasApplianceSpeed"
      v-if="showGasApplianceRegister"
      ref="expandGasAppliances"
    ></expandGasAppliances>
    <p>当前正在进行第 {{ current + 1 }} 步</p>
    <Steps :current="current">
      <Step title="步骤-1" content="选择操作指令及设备信息"></Step>
      <Step title="步骤-2" content="选取设备"></Step>
      <Step title="步骤-3" content="输入参数"></Step>
      <Step title="步骤-4" content="执行操作"></Step>
    </Steps>
    <Row>
      <Col span="5">
        <Card style="width:100%" v-show="current>=1">
          <div style="text-align:left">
            <h5 v-show="current>=1">操作类型：{{instructionLabel}}</h5>
            <h5 v-show="current>=2">设备编号：{{meterLabel.meterId}}</h5>
          </div>
        </Card>
      </Col>
      <Col span="16"></Col>
    </Row>
    <div style="width:30%; left:30%; position:relative; margin-top:15px;">
      <expandStep1
        ref="step1"
        v-show="showStep1"
        v-on:listenToChild1SelectEvent="showLabel"
        v-on:listenToChild1NextEvent="nextEvent"
      ></expandStep1>
    </div>
    <div style="width:100%; left:0%; position:relative; margin-top:15px;">
      <expandStep2
        ref="step2"
        v-show="showStep2"
        v-on:listenToChild2EventForButton="enabledButton"
        v-on:listenToChild2EventForMeterId="getMeterId"
      ></expandStep2>
    </div>
    <div style="width:100%; left:0%; position:relative; margin-top:15px;">
      <expandStep3
        width="width"
        height="height"
        ref="step3"
        v-show="showStep3"
        :speedGroup="speedValueGroup"
        :msgInstructionLabel="instructionLabel"
        :msgInstructionUp="instructionUp"
        v-on:listenToChild3Event="getInputData"
        v-on:listenToChild3EventNext="nextEvent"
      ></expandStep3>
    </div>
    <div style="width:100%; text-align:center; position:relative; margin-top:15px;">
      <expandStep4
        ref="step4"
        :result="result"
        :msg="msg"
        v-show="showStep4"
        :on-ok="callBackReturn"
      ></expandStep4>
    </div>
    <div>
      <Button class="button" type="primary" @click="pre" :disabled="disabledButtonPre">上一步</Button>
      <Tooltip :content="tipContent" placement="right" :disabled="disabledTooltip">
        <Button class="button" type="primary" @click="next" :disabled="disabledButtonNext">下一步</Button>
      </Tooltip>
    </div>
  </div>
</template>
<script>
import expandStep1 from "./expand/InstructionsDetailedStep1.vue";
import expandStep2 from "./expand/InstructionsDetailedStep2.vue";
import expandStep3 from "./expand/InstructionsDetailedStep3.vue";
import expandStep4 from "./expand/opResult.vue";
import expandGasAppliances from "./expand/GasAppliancesRegister.vue";
export default {
  name: "instructions_detailed_menu",
  computed: {
      divStyle() {
          var style = {};
          if(this.$parent.$refs.mainContent){
              style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
          }else{
              style.width = window.innerWidth - 279 + "px";
          }
          // style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
          return style;
      }
  },
  data() {
    return {
      showGasApplianceRegister: false,
      speedValueGroup: {
        speed1: 0,
        speed2: 0,
        speed3: 0
      },
      current: 0,
      showStep1: true,
      showStep2: false,
      showStep3: false,
      showStep4: false,
      tipContent: "请填写数据！",
      tipContent1: "请填写数据！",
      tipContent2: "必须选择一条数据！",
      tipContent3: "请填写参数！",
      tipContent4: "请返回！",
      disabledTooltip: false,
      disabledButtonNext: true,
      disabledButtonPre: true,
      viewMeterDetailed: {},
      instructionCondition: {},
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      instructionLabel: "",
      instructionUp: "",
      instructionType: "",
      meterLabel: "",
      inputData: {},
      result: "",
      msg: ""
    };
  },
  methods: {
    getGasApplianceSpeed() {
      this.speedValueGroup.speed1 = this.$refs.expandGasAppliances.speed1;
      this.speedValueGroup.speed2 = this.$refs.expandGasAppliances.speed2;
      this.speedValueGroup.speed3 = this.$refs.expandGasAppliances.speed3;
      this.$refs.step3.setGasApplianceSpeed();
      this.showGasApplianceRegister = false;
    },
    next() {
      if (this.current == 3) {
      } else if (this.current == 0) {
        //第一页跳第二页
        this.current += 1;
        //查询表具信息,默认第一页
        this.viewMeterDetailed[
          "addressLowestLevelAddressIds"
        ] = this.$refs.step1.addressDataSelect;
        this.viewMeterDetailed[
          "customerIdcard"
        ] = this.$refs.step1.formItem.inputIdCard;
        this.viewMeterDetailed[
          "meterId"
        ] = this.$refs.step1.formItem.inputMeterId;
        this.viewMeterDetailed[
          "meterType"
        ] = this.$refs.step1.formItem.selectMeterType;
        this.$refs.step2.currentPage = 1;
        this.$refs.step2.getMeterList(this.viewMeterDetailed);
        
        this.showStep1 = false;
        this.showStep2 = true;
        //限制选择
        this.disabledTooltip = false;
        // if (this.$refs.step2.selectIndex == -1){
        //     this.disabledButtonNext = true; //按钮不可用
        // } else {
        //     this.disabledButtonNext = false; //按钮不可用
        // }
        this.disabledButtonNext = true; //按钮不可用
        this.disabledButtonPre = false; //按钮可用
        this.tipContent = this.tipContent2;
      } else if (this.current == 1) {
        //第二页跳第三页
        this.current += 1;
        this.instructionCondition["commandDeviceId"] = this.$refs.step2.data[
          this.$refs.step2.selectIndex
        ].meterId;
        //this.instructionCondition["commandType"] = JSON.parse(this.$refs.step1.formItem.select).up;
        this.$refs.step3.getInstructionList(this.instructionCondition);
        this.instructionCondition["commandType"] = JSON.parse(
          this.$refs.step1.formItem.select
        ).down;
        this.$refs.step3.getDownInstruction(this.instructionCondition);
        this.showStep2 = false;
        this.showStep3 = true;
        if (this.instructionCondition["commandType"] == "0x17") {
          this.showGasApplianceRegister = true;
        }

        //限制输入
        this.disabledTooltip = false;
        this.disabledButtonNext = true; //按钮bu可用
        this.tipContent = this.tipContent3;
      } else if (this.current == 2) {
        //第三页跳第四页
        var that = this;
        if(!that.$refs.step3.checkParms()){
          that.$Modal.confirm({
              title: '操作确认',
              content: '当前下发参数可能异常，是否继续下发',
              okText: '下发',
              cancelText: '取消',
              onOk: () => {
                this.current += 1;
                that.$refs.step3.isShowSpin(true);
                $.ajax({
                  url: "/api/instructions/downInstructionData",
                  contentType: "application/json",
                  type: "post",
                  data: JSON.stringify(that.inputData),
                  dataType: "json",
                  success: function(receiveData) {
                    if (receiveData.errorCode == 0) {
                      that.result = "success";
                      that.msg = "完成下发，点击返回";
                      that.$refs.step4.changeStatus(that.result);
                    } else {
                      that.result = "fail";
                      that.msg = "查询数据失败。";
                      that.$refs.step4.changeStatus(that.result);
                      that.$Notice.error({
                        title: "异常",
                        desc: receiveData.errorInfo
                      });
                    }
                    that.showStep3 = false;
                    that.showStep4 = true;
                    //限制输入
                    that.disabledTooltip = false;
                    that.disabledButtonNext = true; //按钮不可用
                    that.disabledButtonPre = true; //按钮不可用
                    that.tipContent = that.tipContent4;
                    that.$refs.step3.isShowSpin(false);
                  },
                  error: function(textStatus) {
                    that.$Notice.error({
                      title: "异常",
                      desc: "接口请求异常"
                    });
                  }
                });
              },
              onCancel: () => {
              }
          });
        }else{
          this.current += 1;
          that.$refs.step3.isShowSpin(true);
          $.ajax({
            url: "/api/instructions/downInstructionData",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify(that.inputData),
            dataType: "json",
            success: function(receiveData) {
              if (receiveData.errorCode == 0) {
                that.result = "success";
                that.msg = "完成下发，点击返回";
                that.$refs.step4.changeStatus(that.result);
              } else {
                that.result = "fail";
                that.msg = "查询数据失败。";
                that.$refs.step4.changeStatus(that.result);
                that.$Notice.error({
                  title: "异常",
                  desc: receiveData.errorInfo
                });
              }
              that.showStep3 = false;
              that.showStep4 = true;
              //限制输入
              that.disabledTooltip = false;
              that.disabledButtonNext = true; //按钮不可用
              that.disabledButtonPre = true; //按钮不可用
              that.tipContent = that.tipContent4;
              that.$refs.step3.isShowSpin(false);
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            }
          });
        }
        
      } else {
        this.current += 1;
      }
    },
    pre() {
      if (this.current == 0) {
      } else if (this.current == 1) {
        this.current -= 1;
        this.showStep1 = true;
        this.showStep2 = false;
        //限制
        this.disabledTooltip = true;
        this.disabledButtonNext = false; //按钮可用
        this.disabledButtonPre = true; //按钮不可用
      } else if (this.current == 2) {
        this.current -= 1;
        this.showStep2 = true;
        this.showStep3 = false;
        //限制
        this.disabledTooltip = true;
        this.disabledButtonNext = false; //按钮可用
        this.tipContent = this.tipContent2;
      } else if (this.current == 3) {
        this.current -= 1;
      } else {
        this.current -= 1;
      }
    },
    enabledButton(param) {
      if (param == -1) {
        this.disabledTooltip = false;
        this.disabledButtonNext = true; //按钮不可用
      } else {
        this.disabledTooltip = true;
        this.disabledButtonNext = false; //按钮可用
      }
    },
    showLabel(param) {
      this.instructionLabel = param.label;
      this.instructionType = param.value;
      this.instructionUp = JSON.parse(this.$refs.step1.formItem.select).up;
    },
    getMeterId(param) {
      this.meterLabel = param;
    },
    getInputData(param) {
      this.inputData["deviceId"] = this.meterLabel.meterId;
      var downType = JSON.parse(this.instructionType);
      var i = downType.down;
      this.inputData["commandType"] = i;
      this.inputData["command"] = {};
      this.inputData.command["paras"] = param;
    },
    callBackReturn() {
      this.$parent.reloadPage();
    },
    nextEvent(param) {
      if (param) {
        this.disabledTooltip = true;
        this.disabledButtonNext = false; //按钮可用
      } else {
        this.disabledTooltip = false;
        this.disabledButtonNext = true; //按钮不可用
        this.tipContent = this.tipContent1;
      }
    }
  },
  components: {
    expandStep1,
    expandStep2,
    expandStep3,
    expandStep4,
    expandGasAppliances
  }
};
</script>

<style>
.button {
  margin-right: 5px;
}
.ivu-table-large th {
  height: 30px;
}
.ivu-table-large td {
  height: 30px;
}
.ivu-table td,
.ivu-table th {
  min-width: 0;
  height: 30px;
  box-sizing: border-box;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  border-bottom: 1px solid #e8eaec;
}
</style>